import { clsx } from "clsx";
import type { FC } from "react";

import type { ProjectActivity as ProjectActivityGql, User } from "../../graphql.js";
import { isCurrentUserActivity } from "../../redux/modules/project.js";
import { Avatar } from "../core/UserAvatar.js";
import { ProjectActivityBody } from "./ProjectActivityBody.js";

export interface IProjectActivityProps {
  activity: ProjectActivityGql;
  currentUser: User;
  className?: string;
  onDeleteClicked?: (activity: ProjectActivityGql) => void;
  users: User[];
}

/**
 * Renders a single activity in the activity list of the ProjectActivityPanel or in the NotificationsDrop-down or directly in an in-app alert.
 *   Renders the icon or the alias built from the name and the box for the activity.
 */
export const ProjectActivity: FC<IProjectActivityProps> = (props) => {
  const currentUserActivity: boolean = isCurrentUserActivity(props.activity, props.currentUser);
  const bubbleClasses = clsx("convo-text inline ", { "self-activity": currentUserActivity });
  const className = clsx("activity-item convo-item", props.className);

  return (
    <li className={className} key={props.activity.id} id={props.activity.id}>
      <div>
        <div className="thumbnail-wrapper" style={{ width: 32, height: 32 }}>
          {!currentUserActivity && <Avatar key={"thumb" + props.activity.id} user={props.activity.user} size={32} />}
        </div>
        <div key={"inner" + props.activity.id} className={bubbleClasses}>
          <ProjectActivityBody
            activity={props.activity}
            users={props.users}
            isCurrentUserActivity={currentUserActivity}
            onDeleteClicked={props.onDeleteClicked}
          />
        </div>
      </div>
    </li>
  );
};
